import React from 'react';
export default function LoadingLoop() {
  return <div className="loading-loop" role="status"><span className="loading-spinner" aria-hidden="true" /><span>Cargando lecturas…</span></div>;
}
